namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_form extends $.$shm_hitalama_map_widget_float_ai_request_form {
		
		@ $mol_mem
		text( next?: string ): string {
			return this.Widget().widget().text(next) ?? ''
		}
		
		next_request( next?: any ) {
			const Widget  = this.Widget()
			const x = Widget.left() + Widget.width() + 25
			const y = Widget.top()

			const widget = Widget.presets().ai_request( [x, y] )
			widget?.ai_request().request_type( this.next_request_type() )
			widget?.ai_request().parent_id( Widget.widget().link_str() )
		}
		
	}
}
